<button 
  mat-raised-button 
  color="{{color}}"
  type="button" 
  [disabled]="disabled || loading"
  (click)="onButtonClick()">
  <span *ngIf="loading"><mat-spinner  diameter="20" class="button-spinner"></mat-spinner>{{textLoading}}</span>
  <span *ngIf="!loading">{{ text }}</span>
</button>